import IconSms from "@mui/icons-material/Sms";
import { UiFab } from "@smp/ui";

import { useContextSupportMessenger } from "@/context/support_messenger";

import classes from "./support_messenger.module.css";

export const SupportMessenger = () => {
  const {
    state: { service },
    actions: { open },
  } = useContextSupportMessenger();

  const handleClick = () => open();

  if (service === "jivo") {
    return null;
  }

  return (
    <UiFab
      className={classes.fab}
      color="default"
      id="intercom-btn"
      onClick={handleClick}
      size="medium"
    >
      <IconSms fontSize="medium" color="primary" />
    </UiFab>
  );
};
